import { apiFetch } from "./client";

/**
 * What the server was built from (public, `GET /api/version`, 2026-10-09): the
 * VERSION file of the repo, the short git commit and the build time; "dev" /
 * "local" / null outside CI.
 */
export type VersionView = { version: string; buildSha: string; buildTime: string | null };

export const versionApi = {
  get: () => apiFetch<VersionView>("/version"),
};
